import { storage, storageKeys } from '@/constants/storage';
import type { Shop } from '@/types/appointment';
import type { Cart } from '@/types/booking';
import type { BnplCheckoutVariant } from '@/utils/bnplExperiment';
import {
  BNPL_CHECKOUT_VARIANT_CONTROL,
  BNPL_EXPERIMENT_FLAG_KEY,
  parseBnplCheckoutVariant,
} from '@/utils/bnplExperiment';

import { useLaunchDarklyFlag } from '../../flags/useLaunchDarklyFlag';
import { useBnplEligibility } from '../useBnplEligibility';

export const useBnplCheckoutVariant = (
  cart: Cart | null | undefined,
  shop: Shop | null | undefined,
): BnplCheckoutVariant => {
  // SQR-15886: any eligible provider enrolls, not only Afterpay.
  const { isEligible } = useBnplEligibility(cart, shop);

  const flagValue = useLaunchDarklyFlag<string>(
    BNPL_EXPERIMENT_FLAG_KEY,
    BNPL_CHECKOUT_VARIANT_CONTROL,
    { enabled: isEligible },
  );

  const override = storage.getString(storageKeys.bnplVariantOverride);
  if (override) return parseBnplCheckoutVariant(override);

  return parseBnplCheckoutVariant(flagValue);
};
